import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-gamepad-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
                黄油网页游戏合集
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费在线畅玩黄油网页游戏合集，精选优质黄油网页游戏，无需下载即点即玩。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/role-playing" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">游戏分类</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/role-playing" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">角色扮演</Link></li>
              <li><Link to="/category/strategy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">策略战棋</Link></li>
              <li><Link to="/category/casual" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">休闲益智</Link></li>
              <li><Link to="/category/mmo" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">多人联机</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                contact@butterwebgames.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                广州市天河区
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 黄油网页游戏合集 - 保留所有权利
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}